import React from "react";

import Sidebar from "../../components/Sidebar";
import BusinessTable from "../../components/businessTable";


function BusinessPage() {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      {/* Sidebar handles its own desktop/mobile rendering */}
      <Sidebar />

      {/* Main content — scrolls independently */}
      <div className="overflow-y-auto flex-1 p-4 md:py-7">
        <BusinessTable />
      </div>
    </div>
  );
}

export default BusinessPage;
